export const UI_SET_HEADER_HIDDEN = 'UI_SET_HEADER_HIDDEN';
export const UI_SET_FOOTER_HIDDEN = 'UI_SET_FOOTER_HIDDEN';
